import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ClassroomIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12.1 3.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M10 5a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h7zM9 8V7H4v1h5zM10 15a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1v-3a1 1 0 011-1h7zm-1 3v-1H4v1h5z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M9.2 22.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM4.918 23.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M22 6a1 1 0 00-1-1h-7a1 1 0 00-1 1v3a1 1 0 001 1h7a1 1 0 001-1V6zm-2 1v1h-5V7h5z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M19.1 13.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM17.018 12.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM9.2 12.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        }),
                        _jsx("path", {
                            d: "M22 16a1 1 0 00-1-1h-7a1 1 0 00-1 1v3a1 1 0 001 1h7a1 1 0 001-1v-3zm-2 1v1h-5v-1h5z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M19.1 23.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM17.018 22.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM6.018 12.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        })
                    ]
                })
            })
        ]
    });
};
ClassroomIcon.isCarinaIcon = true;
export default ClassroomIcon;
